import { Routes } from '@angular/router';

export const lyfeVaultRoutes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/lyfe-vault',
    pathMatch: 'full',
  },
  {
    path: 'vault/:id',
    loadComponent: () => import('#pages/vault/vault.page').then((m) => m.VaultPage),
  },
  {
    path: 'vault',
    loadComponent: () => import('#pages/vault/vault.page').then((m) => m.VaultPage),
  },
];
